export const apiUrl =
  process.env.NODE_ENV !== 'production'
    ? 'http://localhost:5052'
    : 'https://yum-yum-chat.onrender.com';

export const LOCAL_STORAGE_TOKEN_NAME = 'yumyumtoken';
export const LOAD_SUCCESS = 'LOAD_SUCCESS';
export const DELETE_SUCCESS = 'DELETE_SUCCESS';
export const GET_CONVERSATION_DETAIL_SUCCESS =
  'GET_CONVERSATION_DETAIL_SUCCESS';
export const UPDATE_CONVERSATION_SUCCESS = 'UPDATE_CONVERSATION_SUCCESS';
export const COLOR = {
  RED: '#ffa39e',
  GREEN: '#b7eb8f',
  BLUE: '#91d5ff',
};

export const PushEventEnum = {
  NEW_CONVERSATION: 'NEW_CONVERSATION',
  NEW_MESSAGE: 'NEW_MESSAGE',
  CONVERSATION_GROUP_CREATED: 'CONVERSATION_GROUP_CREATED',
  CONVERSATION_GROUP_JOINED: 'CONVERSATION_GROUP_JOINED',
  CONVERSATION_GROUP_LEFT: 'CONVERSATION_GROUP_LEFT',
  CONVERSATION_UPDATED: 'CONVERSATION_UPDATED',
  MESSAGE_SEEN: 'MESSAGE_SEEN',
  CONVERSATION_AVATAR_UPDATED: 'CONVERSATION_AVATAR_UPDATED',
};

export const colorPlaceholderAvatar = [
  '#1ABC9C',
  '#16A085',
  '#2ECC71',
  '#27AE60',
  '#00b894',
  '#55efc4',
  '#81ecec',
  '#74b9ff',
  '#a29bfe',
  '#0984e3',
  '#3498DB',
  '#2980B9',
  '#6c5ce7',
  '#9B59B6',
  '#8E44AD',
  '#fd79a8',
  '#ff7675',
  '#fab1a0',
  '#e17055',
  '#34495E',
  '#2C3E50',
  '#F1C40F',
  '#F39C12',
  '#E67E22',
  '#D35400',
  '#E74C3C',
  '#C0392B',
];

export function shuffle(array) {
  let currentIndex = array.length,
    randomIndex;
  // While there remain elements to shuffle.
  while (currentIndex !== 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }
  return array;
}
